import React, { useEffect, useRef, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CVFilterListings from "./CVFilterListings/CVFilterListings";
import FilterAll from "../FilterAll/FilterAll";
import { getFilterwithcategory } from "../../../../redux/filter/action";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import { titlevalidation } from "../../../Common/commonvalidation";
import OTSSearch from "../../../Common/Search/OTSSearch";

export default function SearchDownloadCVByCategory() {
  const path = "Assets/scss/searchdownloadcv.module.scss";
  const path1 = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
    LoadCSSforfirstTime(path1);
  }, [path, path1]);
  const location = useLocation();
  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const indcatsub = location?.state?.indcatsub;
  const [showError, setShowError] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const debounceTimeout = useRef(null);
  const { state, setSearch } = useAllFilterBaseContext();

  const [totalandsize, setTotalandsize] = useState({
    total: 0,
    size: 0,
  });
  const { pageNumber } = state;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFilterwithcategory(7, indcatsub?.category_id));
    localStorage.removeItem("downloaded");
  }, []);

  const formik = useFormik({
    initialValues: {
      search: "",
    },
    validationSchema: Yup.object({
      search: titlevalidation,
    }),
    onSubmit: (values) => {
      setSearch(values.search);
      // window.scrollTo(0, 450);
    },
  });

  useEffect(() => {
    // Clear timeout if the user types again before delay
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set timeout for 500ms (or whatever delay you prefer)
    debounceTimeout.current = setTimeout(() => {
      setDebouncedSearch(formik.values.search);
    }, 500); // 500ms debounce delay

    return () => clearTimeout(debounceTimeout.current);
  }, [formik.values.search]);

  useEffect(() => {
    // if (debouncedSearch !== "") {
    setSearch(debouncedSearch);
    // window.scrollTo(0, 450);
    // }
  }, [debouncedSearch]);

  useEffect(() => {
    if (formik.touched && formik.errors) {
      setShowError(true);
      const timer = setTimeout(() => {
        setShowError(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [formik.errors, formik.touched, "documents"]);

  useEffect(() => {
    if (formik.isSubmitting && formik.errors) {
      setShowError(true);
    }
  }, [formik.isSubmitting, formik.errors]);

  return (
    <div className="col-lg-10 mx-auto searchdownloadcv">
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${lan}/searchdownloadcv`)}>{indcatsub?.industry_name} &gt;</a>{" "}
        {indcatsub?.category_name}
      </p>

      <div className="search-first">
        <h2>Search result for : {indcatsub?.category_name}</h2>
        <div className="search-bar" style={{ width: "60%" }}>
          <form onSubmit={formik.handleSubmit} className="w-100">
            <input
              id="search"
              name="search"
              type="text"
              placeholder="Search Here"
              className="form-control"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.search}
            />
            {formik.values.search.length > 0 && <button className="search-close" onClick={() => formik.setFieldValue("search", "")} >&#x2715;</button>}
            <button className="btn search-btn " type="submit">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
                alt=""
              />
            </button>
          </form>
        </div>
        {/* <div className="search-bar" style={{ width: "60%" }}>
          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search Here`}
          />
        </div> */}
      </div>
      <h6>
        Viewing{" "}
        {totalandsize?.size > totalandsize?.total
          ? totalandsize?.total
          : `${totalandsize?.size * pageNumber + 1}-${Math.min(
            totalandsize?.size * (pageNumber + 1),
            totalandsize?.total
          )}`}{" "}
        of {totalandsize?.total} results available for hire
      </h6>
      <div className="row">
        <div className="col-lg-3 col-md-4">
          <FilterAll />
        </div>
        <div className="col-lg-9 col-md-8 filter-right">
          <CVFilterListings setTotalandsize={setTotalandsize} />
        </div>
      </div>
    </div>
  );
}
